import useLogger from "../hooks/useLogger";

const withLogger = (WrappedComponent) => (props) => {
  const logger = useLogger();
  return <WrappedComponent {...props} logger={logger} />;
};

export default withLogger;
